import { useState } from 'react';
import { clsx } from 'clsx';
import { Icon } from './ui/Icon';
import { useEditor } from '@/store/editor';

const styles = ['Fotorealistisk', 'Anime', 'Svartvit 35mm', 'Pixar-stil', 'Akvarell', 'Cyberpunk', 'Drom', 'Skiss'];
const types = ['Bild', 'Video 4s', 'Bakgrund', 'Musik'];

export function GenerateModal() {
  const open = useEditor((s) => s.generateOpen);
  const close = useEditor((s) => s.closeGenerate);
  const setToast = useEditor((s) => s.setToast);
  const [activeStyle, setActiveStyle] = useState(0);
  const [activeType, setActiveType] = useState(0);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-[10px] flex items-center justify-center"
      onClick={(e) => {
        if (e.target === e.currentTarget) close();
      }}
    >
      <div className="w-[90%] max-w-[700px] bg-bg-elevated border border-border-strong rounded-2xl overflow-hidden animate-[modalIn_0.25s_ease]">
        <div className="p-5 border-b border-border flex items-center gap-3.5">
          <div className="w-9 h-9 rounded-[9px] bg-gradient-to-br from-ai to-accent flex items-center justify-center text-white">
            <Icon name="sparkles" size={18} />
          </div>
          <div>
            <div className="font-semibold text-[15px]">Skapa med AI</div>
            <div className="text-text-muted text-xs">Beskriv vad du vill ha eller valj en mall</div>
          </div>
        </div>
        <div className="px-6 py-5">
          <textarea
            className="w-full min-h-[90px] px-4 py-3 bg-bg-panel border border-border rounded-[10px] text-text text-sm resize-y outline-none focus:border-ai mb-5 font-sans"
            placeholder="En filmisk etablerande bild av Stockholm i morgonljus, varmt ljus, ultrarealistisk..."
          />
          <Label>Stil</Label>
          <Grid cols={4}>
            {styles.map((s, i) => (
              <PresetBtn key={s} active={i === activeStyle} onClick={() => setActiveStyle(i)}>
                {s}
              </PresetBtn>
            ))}
          </Grid>
          <Label>Typ</Label>
          <Grid cols={4}>
            {types.map((t, i) => (
              <PresetBtn key={t} active={i === activeType} onClick={() => setActiveType(i)}>
                {t}
              </PresetBtn>
            ))}
          </Grid>
        </div>
        <div className="flex justify-end gap-2 px-6 py-3.5 bg-bg-panel border-t border-border">
          <button className="btn" onClick={close}>
            Avbryt
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              close();
              setToast('Skapar med RTX 4060...');
            }}
          >
            <Icon name="sparkles" size={14} />
            Skapa
          </button>
        </div>
      </div>
    </div>
  );
}

function Label({ children }: { children: React.ReactNode }) {
  return <div className="text-[11px] text-text-subtle uppercase mb-2.5 font-semibold tracking-wider">{children}</div>;
}

function Grid({ cols, children }: { cols: number; children: React.ReactNode }) {
  return (
    <div className={`grid gap-2 mb-5`} style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
      {children}
    </div>
  );
}

function PresetBtn({
  children,
  active,
  onClick,
}: {
  children: React.ReactNode;
  active?: boolean;
  onClick?: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className={clsx(
        'px-2 py-2.5 rounded-lg text-xs text-center cursor-pointer transition-all',
        active
          ? 'border border-ai bg-[rgba(167,139,250,0.15)] text-text'
          : 'border border-border bg-bg-panel text-text-muted hover:border-border-strong hover:text-text',
      )}
    >
      {children}
    </button>
  );
}
